/* tslint:disable jsx-no-lambda */
import * as React from 'react'
import { Link, Route, Switch } from 'react-router-dom'
import { Riders } from '../icons/main-menu'
import TripsDashboardFilter from 'src/containers/trips/TripsDashboardFilter'
import { ITripFilters, IRecentTripObj } from 'src/types'
import { useDriverManifestsContext } from '../driver-manifests/DriverManifestsContext'
import { Button } from '@mobiscroll/react-latest'

const sectionHeading = (
  title: string,
  returnPath: string,
  routeProps: any,
  isUpdated?: boolean,
  setRefresh?: (value: boolean) => void
) => {
  const isDriverManifests = title === 'Driver Manifests'
  return (
    <div className={isDriverManifests ? 'pl1 flex items-center driver-manifests-header' : 'pl1 flex items-center'}>
      <div className=''>
        <Link to={returnPath}>
          <h2 className='pl1 m0 '>{title}</h2>
        </Link>
      </div>
      {isDriverManifests && (
        <div className='flex mr3 items-center'>
          {isUpdated ? (
            <div className='flex flex-row items-center'>
              <span className='dm-status-dot ' style={{ background: 'green', minWidth: '10px' }} />
              <span className='h6 font-grey2'>Live Updates</span>
            </div>
          ) : (
            <div className='flex flex-row items-center'>
              <span className='dm-status-dot ' style={{ background: 'red', minWidth: '10px' }} />
              <span className='h6 font-grey2'>Please Refresh...</span>
            </div>
          )}
          <div className='dm-refresh-button'>
            <Button
              className='mbsc-refresh-button'
              icon='stream-sync'
              onClick={() => {
                if (setRefresh) {
                  setRefresh(true)
                }
              }}
            >
              Refresh
            </Button>
          </div>
        </div>
      )}
    </div>
  )
}

const TopBar = (props: {
  showMembers?: () => void
  currentOrganizationId: string
  tripTitle: string
  updateTripFilters: (filters: ITripFilters) => void
  tripFilters: ITripFilters
  trip: IRecentTripObj
}) => {
  const { tripTitle, tripFilters, trip } = props
  const { isUpdated, setRefresh } = useDriverManifestsContext()
  return (
    <div className='TopBar flex items-center bwidth1 justify-between'>
      <div className='SectionHeader flex font-dark-grey'>
        <Switch>
          <Route
            path='/trips-history'
            render={(props: any) => sectionHeading('Trips History', '/trips-history', props)}
          />
          <Route path='/live-drivers' render={(props: any) => sectionHeading('Live Drivers', '/live-drivers', props)} />
          <Route path='/trips' render={(props: any) => sectionHeading(tripTitle, '/trips', props)} />
          <Route
            path='/trips-management'
            render={(props: any) => sectionHeading('Trips Management', '/trips-management', props)}
          />
          <Route
            path='/billing-management'
            render={(props: any) => sectionHeading('Billing Management', '/billing-management', props)}
          />
          <Route path='/providers' render={(props: any) => sectionHeading('Providers', '/providers', props)} />
          <Route path='/products' render={(props: any) => sectionHeading('Products', '/products', props)} />
          <Route path='/team-members' render={(props: any) => sectionHeading('Team members', '/team-members', props)} />
          <Route path='/station-user' render={(props: any) => sectionHeading('Station User', '/station-user', props)} />
          <Route path='/riders' render={(props: any) => sectionHeading('Riders', '/riders', props)} />
          <Route
            path='/mobility-options'
            render={(props: any) => sectionHeading('Mobility Options', '/mobility-options', props)}
          />
          <Route path='/services' render={(props: any) => sectionHeading('Services', '/services', props)} />
          <Route
            path='/assistance'
            render={(props: any) => sectionHeading('Assistance Requirements', '/assistance', props)}
          />
          <Route
            path='/organizations'
            render={(props: any) => sectionHeading('Organizations', '/organizations', props)}
          />
          <Route
            path='/global-settings'
            render={(props: any) => sectionHeading('Global Settings', '/global-settings', props)}
          />
          <Route
            path='/station-user-trips'
            render={(props: any) => sectionHeading('Station User Trips', '/station-user-trips', props)}
          />
          <Route path='/drivers' render={(props: any) => sectionHeading('Drivers', '/drivers', props)} />
          <Route path='/vehicles' render={(props: any) => sectionHeading('Vehicles', '/vehicles', props)} />
          <Route path='/promotions' render={(props: any) => sectionHeading('Promotions', '/promotions', props)} />
          <Route
            path='/trip-feedbacks'
            render={(props: any) => sectionHeading('Rider/Driver Feedback', '/trip-feedbacks', props)}
          />
          <Route path='/import' render={(props: any) => sectionHeading('Import', '/import', props)} />
          <Route
            path='/driver-manifests'
            render={(props: any) =>
              sectionHeading('Driver Manifests', '/driver-manifests', props, isUpdated, setRefresh)
            }
          />
          <Route path='/scheduler' render={(props: any) => sectionHeading('Requests', '/scheduler', props)} />
          {/* <Route path='/trips' render={(props: any) => sectionHeading('Map', '/trips', props)} /> */}
          <Route render={(props: any) => sectionHeading('Requests', '/', props)} />
        </Switch>
      </div>

      {(/\/trips/.test(location.pathname) && /\/scheduler/.test(location.pathname)) ||
        (props.currentOrganizationId &&
          !/\/trips-management/.test(location.pathname) &&
          !/\/billing-management/.test(location.pathname) &&
          !/\/services/.test(location.pathname) &&
          !/\/station-user/.test(location.pathname) &&
          !/\/riders/.test(location.pathname) &&
          !/\/providers/.test(location.pathname) &&
          !/\/products/.test(location.pathname) &&
          !/\/team-members/.test(location.pathname) &&
          !/\/mobility-options/.test(location.pathname) &&
          !/\/assistance/.test(location.pathname) &&
          !/\/organizations/.test(location.pathname) &&
          !/\/global-settings/.test(location.pathname) &&
          !/\/station-user-trips/.test(location.pathname) &&
          !/\/drivers/.test(location.pathname) &&
          !/\/vehicles/.test(location.pathname) &&
          !/\/promotions/.test(location.pathname) &&
          !/\/trip-feedbacks/.test(location.pathname) &&
          !/\/driver-manifests/.test(location.pathname) &&
          !/\/import/.test(location.pathname) && (
            <div
              className='mt1 flex items-center font-dark-grey'
              style={{ fontWeight: 'bold', cursor: 'pointer', overflowX: 'auto' }}
            >
              <TripsDashboardFilter />
            </div>
          ))}
      {(/\/trips/.test(location.pathname) && /\/scheduler/.test(location.pathname)) ||
        (!/\/trips-management/.test(location.pathname) &&
          !/\/billing-management/.test(location.pathname) &&
          !/\/services/.test(location.pathname) &&
          !/\/station-user/.test(location.pathname) &&
          !/\/riders/.test(location.pathname) &&
          !/\/providers/.test(location.pathname) &&
          !/\/products/.test(location.pathname) &&
          !/\/team-members/.test(location.pathname) &&
          !/\/mobility-options/.test(location.pathname) &&
          !/\/assistance/.test(location.pathname) &&
          !/\/organizations/.test(location.pathname) &&
          !/\/global-settings/.test(location.pathname) &&
          !/\/station-user-trips/.test(location.pathname) &&
          !/\/drivers/.test(location.pathname) &&
          !/\/vehicles/.test(location.pathname) &&
          !/\/promotions/.test(location.pathname) &&
          !/\/trip-feedbacks/.test(location.pathname) &&
          !/\/driver-manifests/.test(location.pathname) &&
          !/\/import/.test(location.pathname) && (
            <div className='mt2 flex items-center font-dark-grey mr1' style={{ fontWeight: 'bold', cursor: 'pointer' }}>
              <div className='flex items-center content-center'>
                <div>
                  <Link to={`/trips`}>
                    <span className='font-dark-grey hover-on pr1'>{'Map'}</span>|
                  </Link>
                </div>
                <div>
                  <Link to={`/scheduler`}>
                    <span className='font-dark-blue hover-on pl1'>{'Timeline'}</span>
                  </Link>
                </div>
                <div onClick={props.showMembers}>
                  <span style={{ marginLeft: '1rem' }}>
                    <Riders className='svg-grey3 cursor--pointer' />
                  </span>
                </div>
              </div>
            </div>
          ))}
      {/* {/\/trips/.test(location.pathname) && /\/scheduler/.test(location.pathname) ||
        !/\/trips-management/.test(location.pathname) &&
        props.currentOrganizationId && (
         
        )} */}
    </div>
  )
}

export default TopBar



// WEBPACK FOOTER //
// ./src/components/navigation/TopBar.tsx